'use client'

import React from 'react'
import styles from './styles.module.css'

interface TextDividerProps {
  onConsultationClick: () => void
}

const TextDivider: React.FC<TextDividerProps> = ({ onConsultationClick }) => {
  return (
    <section className={styles.textDivider}>
      <div className={styles.container}>
        {/* Block heading - на всю ширину */}
        <div className={styles.heading}>
          <h2 className={styles.title}>
            Создаём ИТ-решения, которые повышают эффективность вашего бизнеса
          </h2>
        </div>
        
        {/* Нижняя часть с двумя колонками */}
        <div className={styles.content}>
          {/* Пустая левая колонка */}
          <div className={styles.leftColumn}></div>
          
          {/* Paragraph with button - правая колонка */}
          <div className={styles.rightColumn}>
            <div className={styles.textBlock}>
              <p className={styles.paragraph}>
                Мы<span className={styles.highlight}> находим лучшее решение для ваших задач</span> —
                от заказной разработки до готовых платформ. Глубоко погружаемся в процессы, обеспечиваем прозрачное управление проектом и полный контроль бюджета.
              </p>
              <p className={styles.paragraph}>
                В итоге ваши <span className={styles.highlight}>продукты приносят реальную пользу</span>: сокращают издержки, ускоряют работу и помогают зарабатывать больше.
              </p>
            </div>
            
            <button 
              className={styles.button}
              onClick={onConsultationClick}
            >
              <span className={styles.buttonText}>Получить консультацию</span>
              <svg className={styles.buttonIcon} viewBox="0 0 16 16" fill="none">
                <path d="M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z" fill="white" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

TextDivider.displayName = 'TextDivider'

export default TextDivider
